// @flow

import styled from 'styled-components'
import Link from 'gatsby-link'

const UnstyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

export default UnstyledLink



// WEBPACK FOOTER //
// ./src/components/typography/unstyled-link.js